var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchWhie(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.109 -0.109)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    transform: "translate(0.109 0.109)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-202.472,269.567l-.011-.012-2.956-2.959a7.256,7.256,0,0,0,1.222-2.642.35.35,0,0,0,.01-.061,12.287,12.287,0,0,0-.015-5.516,7.337,7.337,0,0,0-5.428-5.481.543.543,0,0,0-.066-.02,12.292,12.292,0,0,0-5.579,0h0a7.337,7.337,0,0,0-5.5,5.5,12.3,12.3,0,0,0,0,5.581,7.335,7.335,0,0,0,5.5,5.5,12.245,12.245,0,0,0,2.79.32,12.28,12.28,0,0,0,2.788-.32h.006a7.254,7.254,0,0,0,2.636-1.218l2.972,2.967a1.153,1.153,0,0,0,.789.31,1.154,1.154,0,0,0,.847-.367A1.159,1.159,0,0,0-202.472,269.567Zm-7.776-2.367a9.962,9.962,0,0,1-4.519,0,5.036,5.036,0,0,1-3.778-3.774,9.948,9.948,0,0,1,0-4.522,5.036,5.036,0,0,1,3.778-3.775h0a9.962,9.962,0,0,1,4.519,0,5.035,5.035,0,0,1,3.773,3.779,9.953,9.953,0,0,1,0,4.523.509.509,0,0,0-.009.052,5.035,5.035,0,0,1-3.758,3.718Z",
    transform: "translate(222.971 -250.704)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhie);
export default __webpack_public_path__ + "static/media/searchWhie.1c94f74e72002c150b13e42df8f2243c.svg";
export { ForwardRef as ReactComponent };